<template>
  <div class="select-box">
    <div class="select-btn left-btn" :class="item.role==1 ? 'selected' : 'default'" @click="handleSwitch(1)">管理员</div><div class="select-btn right-btn" :class="item.role==2 ? 'selected' : 'default'" @click="handleSwitch(2)">浏览者</div>
  </div>
</template>
<script>
  export default {
    props:['item'],
    methods: {
      handleSwitch(role) {
        if (this.item.role != role) {
          this.item.role = role;
          this.$emit('switchRole', {userName:this.item.userName,role:role});
        }
      }
    }
  };
</script>
<style lang="scss" scoped>
  .select-box {
    display: inline-block;
    width: 120px;
    height: 30px;
    line-height:30px;
    border: 1px solid #ccc;
    background-color: #fff;
    overflow: hidden;
    border-radius: 15px;
    font-size: 12px;
    cursor: pointer;
  }
  .select-btn {
    display: inline-block;
    width: 50%;
    height: 30px;
    line-height: 30px;
    text-align: center;
  }
  .left-btn {
    border-right: 1px solid #ccc;
  }
  .selected {
    background-color: #FF552E;
    color: #fff;
  }
  .default {
    &:hover {
       background-color: #ffeeea;
     }
  }
</style>



// WEBPACK FOOTER //
// src/components/wj-switch.vue